<div class="login-container">
    <div class="language-switcher-container">
        <on-language-switcher></on-language-switcher>
    </div>
    <div class="card p-1">
        <img
            class="card-img-top"
            src="assets/logo.png"
            alt="{{ 'auth.logo-alt' | translate }}"
        />
        <div class="card-body">
            <h2 class="card-title">{{ 'auth.sign-in' | translate }}</h2>
            <on-login-form (loginRequested)="Login($event)"></on-login-form>
        </div>
    </div>
</div>
